import { formatDistanceToNow } from 'date-fns';
import type { Device } from '../types';

interface Props {
  devices: Device[];
}

export function FleetHealthCard({ devices }: Props) {
  return (
    <div className="hud-card">
      <div className="hud-corner-tl" /><div className="hud-corner-tr" /><div className="hud-corner-bl" /><div className="hud-corner-br" />
      <div className="hud-card-header">
        <div className="flex items-center gap-2.5">
          <svg className="w-4 h-4 text-hud-green opacity-80" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.2"/>
            <circle cx="8" cy="8" r="2" fill="currentColor"/>
          </svg>
          <span className="hud-card-title">Fleet Health</span>
        </div>
        <span className="hud-card-badge">LIVE</span>
      </div>
      <div className="hud-card-body">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3.5">
          {devices.map((device) => (
            <div
              key={device.deviceId}
              className="bg-black/30 border border-[#152030] p-4 transition-colors hover:border-hud-green-mid"
              style={{ borderRadius: '2px' }}
            >
              <div className="flex items-center justify-between mb-3.5">
                <span className="font-display text-xs font-semibold tracking-[2px] text-hud-white">
                  {device.deviceName}
                </span>
                <div className={`flex items-center gap-1.5 font-mono text-[10px] tracking-wider uppercase ${
                  device.status === 'Online' ? 'text-hud-green' :
                  device.status === 'Recent' ? 'text-hud-amber' : 'text-hud-red'
                }`}>
                  <span className={`status-dot ${
                    device.status === 'Online' ? 'status-dot-online' :
                    device.status === 'Recent' ? 'status-dot-recent' : 'status-dot-offline'
                  }`} />
                  {device.status}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2.5">
                <div>
                  <div className="font-mono text-[9px] tracking-[1.5px] uppercase text-[#3a5a6a]">Last Seen</div>
                  <div className="font-mono text-[13px] text-hud-cyan">
                    {formatDistanceToNow(device.lastSeen, { addSuffix: true })}
                  </div>
                </div>
                <div>
                  <div className="font-mono text-[9px] tracking-[1.5px] uppercase text-[#3a5a6a]">Version</div>
                  <div className="font-mono text-[13px] text-hud-cyan">v{device.version}</div>
                </div>
                <div>
                  <div className="font-mono text-[9px] tracking-[1.5px] uppercase text-[#3a5a6a]">WiFi</div>
                  <div className="font-mono text-[13px] text-hud-cyan truncate">{device.ssid || 'N/A'}</div>
                </div>
                <div>
                  <div className="font-mono text-[9px] tracking-[1.5px] uppercase text-[#3a5a6a]">Memory</div>
                  <div className="font-mono text-[13px] text-hud-cyan">{(device.memFree / 1024).toFixed(1)} KB</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {devices.length === 0 && (
          <p className="font-mono text-sm text-[#3a5a6a] text-center py-8">No devices found</p>
        )}
      </div>
    </div>
  );
}
